import { useNavigate, useSearch } from '@tanstack/react-router';
import { JobCreateSuccessPage as JobCreateSuccessPageComponent } from './JobCreateSuccessPage.component';
import { DEFAULT_JOBS_SEARCH } from '@/features/jobs/jobs-list/jobs-search.schema';

export default function JobCreateSuccessPage() {
  const navigate = useNavigate();
  // `id` is propagated by `job-create` after a successful POST so the
  // user can land directly on the new draft's edit page. Falls back to the
  // list when missing (direct visit / stale bookmark).
  const search = useSearch({ from: '/vagas/nova/sucesso' });
  const jobId = search.id;

  return (
    <JobCreateSuccessPageComponent
      onContinueEditing={() => {
        if (jobId) {
          void navigate({
            to: '/vagas/$jobId',
            params: { jobId },
          });
          return;
        }
        void navigate({ to: '/vagas', search: DEFAULT_JOBS_SEARCH });
      }}
      onBackToJobs={() => {
        void navigate({ to: '/vagas', search: DEFAULT_JOBS_SEARCH });
      }}
    />
  );
}
